import { jsx as t, Fragment as g, jsxs as w } from "react/jsx-runtime";
import { useState as L, useMemo as y, useCallback as v, useLayoutEffect as b } from "react";
import a from "./styles.module.less.js";
import k from "./logo.webp.js";
import { usePathname as A } from "../../../utils/use-pathname.js";
import { AccountLink as I } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as N } from "../../../constants.js";
import { convertToKebabCase as C } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as D } from "./dropdown-menu-item/index.js";
import { MenuItem as E } from "./menu-item/index.js";
import { ForLawyersMenuButtonDesktop as M } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as S } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as $ } from "./chat-button/index.js";
const T = "/help", J = (s) => {
  const { getTranslation: n, language: e, isLawyerSupported: d = !1 } = s, r = A(), [i, p] = L(!1), l = y(() => {
    const o = N[e];
    if (o)
      return [
        ...o.map((u) => ({
          ...u,
          path: `/${e}/topics/${C(u.title)}`
        }))
      ];
  }, [e]), c = v(
    (o) => {
      switch (o) {
        case "/chat":
          return r === "/chat";
        case "/about":
          return r === `/${e}/about`;
        case "/about/company":
          return r === `/${e}/about/company`;
        case "/help":
          return r === T;
        case "/topics":
          return r === `/${e}/topics`;
        case "/account":
          return r === "/account";
        case "/for-lawyers/legal-network":
          return r === `/${e}/for-lawyers/legal-network`;
        default:
          return !1;
      }
    },
    [r, l, e]
  );
  return b(() => {
    const o = () => {
      var h, f;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((h = document.getElementById(m)) == null || h.classList.add(a.shrink), p(!0)) : ((f = document.getElementById(m)) == null || f.classList.remove(a.shrink), p(!1));
    };
    return window.addEventListener("scroll", o), document.body.addEventListener("scroll", o), o(), () => {
      window.removeEventListener("scroll", o), document.body.removeEventListener("scroll", o);
    };
  }, []), /* @__PURE__ */ t(g, { children: /* @__PURE__ */ t("div", { className: a.floatingContainer, id: m, children: /* @__PURE__ */ w("div", { className: a.menuContentContainer, children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: a.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: k,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: a.logo
          }
        )
      }
    ),
    /* @__PURE__ */ w("div", { className: a.menuLinksContainer, children: [
      d ? /* @__PURE__ */ t(
        S,
        {
          language: e,
          titleLabel: n("pages.get-help"),
          getTranslation: n,
          hasShrunk: i,
          isLawyerSupported: !0,
          onRequestLawyer: s.onRequestLawyer,
          isActive: c(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ t(
        $,
        {
          getTranslation: n,
          isScrolledHeader: i
        }
      ),
      d ? null : /* @__PURE__ */ t("div", { className: a.spacer }),
      l ? /* @__PURE__ */ t(
        D,
        {
          language: e,
          items: l,
          titleLabel: n("pages.topics"),
          hasShrunk: i,
          link: `/${e}/topics`,
          classNames: {
            container: a.subMenuContainer,
            itemRow: a.offsetDropdownItemRow
          },
          isActive: c(
            "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      /* @__PURE__ */ t(
        E,
        {
          label: n("pages.about"),
          path: `/${e}/about/company`,
          hasShrunk: i,
          isActive: c(
            "/about/company"
            /* ABOUT_COMPANY */
          )
        }
      ),
      /* @__PURE__ */ t(
        M,
        {
          language: e,
          getTranslation: n,
          isScrolledHeader: i,
          isActive: c(
            "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          )
        }
      ),
      /* @__PURE__ */ t(
        I,
        {
          isScrolledHeader: i,
          isActive: c(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: s.isAuthenticated,
          userImage: s.userImage,
          openAuthModal: s.openAuthModal,
          logout: s.logout,
          hasNotifications: s.hasNotifications,
          language: e,
          getTranslation: n
        }
      )
    ] })
  ] }) }) });
};
export {
  J as DesktopMenu
};
